"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    WifiSlash: function() {
        return WifiSlash;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const WifiSlash = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L6.41593 5.00172C8.15557 4.35378 10.0375 4 12 4C16.0972 4 19.8369 5.54138 22.6669 8.07433C23.0784 8.44266 23.1135 9.07485 22.7451 9.48638C22.3768 9.89791 21.7446 9.93293 21.3331 9.5646C18.8556 7.34716 15.5863 6 12 6C10.6072 6 9.26315 6.20309 7.99514 6.58093L10.5139 9.09968C11.0004 9.03391 11.4966 9 12.0002 9C14.8489 9 17.4468 10.0842 19.3999 11.8608C19.8084 12.2324 19.8384 12.8649 19.4667 13.2734C19.0951 13.682 18.4627 13.7119 18.0541 13.3403C16.5522 11.9741 14.5888 11.11 12.424 11.0098L22.7071 21.2929C23.0976 21.6834 23.0976 22.3166 22.7071 22.7071C22.3166 23.0976 21.6834 23.0976 21.2929 22.7071L9.46947 10.8837C9.46295 10.8773 9.45652 10.8709 9.45017 10.8644L5.48243 6.89664C5.47141 6.88612 5.46061 6.87533 5.45005 6.86426L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289ZM4.04047 7.24445C4.36374 7.69224 4.26278 8.31731 3.81499 8.64057C3.41605 8.92857 3.03284 9.23709 2.66691 9.5646C2.25539 9.93293 1.62319 9.89791 1.25487 9.48638C0.886539 9.07485 0.92156 8.44266 1.33309 8.07433C1.75095 7.70034 2.18862 7.34796 2.64435 7.01897C3.09214 6.6957 3.71721 6.79665 4.04047 7.24445ZM7.69111 10.9181C7.97677 11.3908 7.82517 12.0055 7.3525 12.2912C6.84971 12.5951 6.37886 12.9468 5.94633 13.3403C5.53778 13.7119 4.90532 13.682 4.53369 13.2734C4.16207 12.8649 4.192 12.2324 4.60055 11.8608C5.12851 11.3806 5.70354 10.9509 6.31803 10.5795C6.7907 10.2939 7.40545 10.4455 7.69111 10.9181ZM11.559 14.9193C11.7135 15.4495 11.4089 16.0046 10.8786 16.1591C10.2888 16.3309 9.75408 16.6357 9.30961 17.04C8.90106 17.4116 8.2686 17.3817 7.89698 16.9732C7.52535 16.5646 7.55528 15.9322 7.96383 15.5605C8.62848 14.9559 9.43066 14.4978 10.3192 14.2389C10.8494 14.0844 11.4045 14.389 11.559 14.9193ZM11 20C11 19.4477 11.4477 19 12 19H12.01C12.5623 19 13.01 19.4477 13.01 20C13.01 20.5523 12.5623 21 12.01 21H12C11.4477 21 11 20.5523 11 20Z",
        fill: "currentColor"
    })
}), "WifiSlash");
const _default = WifiSlash;
